var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.319,
    height: 21.598,
    viewBox: "0 0 19.319 21.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "playstore_1_",
    "data-name": "playstore (1)",
    d: "M6.02,1.392,17.389,7.958l-3.234,3.234L3.962,1.1c.2,0,.49-.1.686-.1A2.25,2.25,0,0,1,6.02,1.392ZM2.1,20.013V3.548a2.558,2.558,0,0,1,.98-1.96l10.29,10.29L3.178,22.071A2.557,2.557,0,0,1,2.1,20.013Zm3.92,2.254a3.13,3.13,0,0,1-1.862.294l10-9.9L17.291,15.8,6.02,22.267Zm14.211-8.232-2.058,1.176-3.43-3.332,3.43-3.43,1.96,1.176a2.592,2.592,0,0,1,1.274,2.254,2.364,2.364,0,0,1-1.176,2.156Z",
    transform: "translate(-2.1 -1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore1);
export default __webpack_public_path__ + "static/media/playstore1.9e181328378ced1504eb9d2e00124cd7.svg";
export { ForwardRef as ReactComponent };